import {
  UPDATE_SITES_LIST,
  UPDATE_SITES_LOADING,
} from "../../store/actionTypes";

const initialState = {
  total: 0,
  pageNo: 1,
  limit: 10,
  totalPage: 0,
  searchKey: "",
  sortOrder: 1,
  sortBy: "siteName",
  sitesList: [],
  isLoading: false,
};

const SiteReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SITES_LIST: {
      return { ...state, ...action.payload };
    }
    case UPDATE_SITES_LOADING: {
      return { ...state, ...{ isLoading: !state.isLoading } };
    }
    default:
      return state;
  }
};

export const mediaReducer = (state, action) => {
  switch (action.type) {
    case "ADD": {
      return [...state, ...action.payload];
    }
    case "DELETE":
      return state.filter((item) => item.id !== action.payload);

    case "UPDATE_STATUS_PENDING":
      return state.map((item) =>
        item.id === action.payload ? { ...item, status: "pending" } : item
      );

    case "UPDATE_STATUS_FAILURE":
      return state.map((item) =>
        item.id === action.payload ? { ...item, status: "failure" } : item
      );
    case "DEFAULT_HANDLER":
      return state.map((item) =>
        item.id === action.payload
          ? { ...item, isDefault: true }
          : { ...item, isDefault: false }
      );
    case "UPLOADED_SUCCESSFULLY": {
      return state.map((item) =>
        item.id === action.payload.id
          ? { ...item, status: "success", imageUrl: action.payload.imageUrl }
          : item
      );
    }
    default:
      return state;
  }
};

export default SiteReducer;
